import { eventChannel, buffers } from 'redux-saga'
import { put, all, fork, call, take, race, takeEvery, delay } from 'redux-saga/effects';


import * as c from './constants';
import * as actions from './actions';
import * as api from './api';




export default function* () {
  yield all([
    fork(pairTerminalSaga)
  ]);
}




function* pairTerminalSaga() {
  yield takeEvery(c.TYRO_PAIR_TERMINAL, callPairTerminal);
}
function* callPairTerminal(action) {
  yield put(actions.tyroShowModal());

  const { payload: { mid, tid, callback } } = action;
  
  try {
    if (!mid || !tid) {
      yield put(actions.tyroSetErrorStatus("Merchant ID and terminal ID are required."));
      return;
    }

    const { emitter } = api.tyroPairTerminal(mid, tid);
    const channel = yield call(createEventChannel, emitter, ["message"]);

    const { cancel, integrationKey } = yield race({
      cancel: take(c.TYRO_CANCEL_TRANSACTION),
      integrationKey: call(subscribeTyroPairEvents, channel)
    });

    yield delay(2000);
    yield put(actions.tyroHideModal());

    if (cancel) {
      return;
    }

    callback(integrationKey);

  } catch(err) {
    console.error("@pairTerminalSaga: ", err.message || err);
    callback(null);
  }
}




function* subscribeTyroPairEvents(channel) {
  while (true) {
    const { event, info } = yield take(channel);

    switch (event) {
      case "message": {
        const [ response ] = info;
        const { message, status, integrationKey } = response;
        
        yield put(actions.tyroSetMessageStatus(message));
        
        if (status === "failure") {
          return null;
        }

        if (status === "success") {
          return integrationKey;
        }

        break;
      }
    
      default: {
        break;
      }
    }
  }
}





//
// ─── UTILITY FUNCTIONS ──────────────────────────────────────────────────────────
//
export function createEventChannel(emitter, events) {
  return eventChannel(emit => {
    const eventHandler = (event) => {
      return (...args) => emit({ event, info: args })
    }

    (events || []).forEach(event => {
      emitter.on(event, eventHandler(event));
    })

    const unsubscribe = () => {
      (events || []).forEach(event => {
        emitter.removeListener(event, eventHandler);
      })
    }

    return unsubscribe;
  }, buffers.expanding());
}


